// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-container {
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
}

.sidebarStyle {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    margin: 12px;
    background-color: #404040;
    color: #ffffff;
    z-index: 1 !important;
    padding: 6px;
    font-weight: bold;
}

.marker {
    color: white;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    border-radius: 50%;
}
.marker.small {
    background-color: #f48787;
    border: 1px solid #d76f6f;
    padding: 5px;
}
.marker.equal{
    background-color: #77c6f2;
    border: 1px solid #64b0db;
    padding: 5px;
}
.marker.big {
    background-color: #69bd6df5;
    border: 1px solid #57a85bf5;
    padding: 5px;
}
.mapboxgl-canvas{
    position: static;
}
.mapboxgl-canvas-container.mapboxgl-touch-zoom-rotate.mapboxgl-touch-drag-pan,
.mapboxgl-canvas-container.mapboxgl-touch-zoom-rotate.mapboxgl-touch-drag-pan .mapboxgl-canvas{
    height: 100% !important;
    width: 100% !important;
}
.maincontant{
    height: 100%;
}
.rightsection{
    height: 100vh;
}
.mapcontrol {
    position: fixed;
    z-index: 1;
    right: 25px;
    top: 25px;
    background-color: #fff;
    padding: 15px;
}

.map-dots ul {
    display: flex;
    gap: 10px;
    padding: 0;
    margin: 0;
    justify-content: center;
}

.map-dots ul li {
    list-style-type: none;
    text-align: center;
}

.mapDots {
    /* background-color: #6c8997; */
    border-radius: 50%;
}

.mapDots.small{
    padding: 5px;
    background-color: #f48787;
}
.mapDots.big {
    padding: 5px;
    background-color: #69bd6df5;
}
.mapDots.equal {
    padding: 5px;
    background-color: #77c6f2;
}
.map-height {
    height: 45px;
    display: flex;
    align-items: end;

}`, "",{"version":3,"sources":["webpack://./src/css/Map.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,UAAU;IACV,WAAW;IACX,SAAS;IACT,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,UAAU;IACV,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,2BAA2B;AAC/B;AACA;IACI,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;;AAEpB","sourcesContent":[".map-container {\n    position: relative;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 100%;\n}\n\n.sidebarStyle {\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    margin: 12px;\n    background-color: #404040;\n    color: #ffffff;\n    z-index: 1 !important;\n    padding: 6px;\n    font-weight: bold;\n}\n\n.marker {\n    color: white;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    border-radius: 50%;\n}\n.marker.small {\n    background-color: #f48787;\n    border: 1px solid #d76f6f;\n    padding: 5px;\n}\n.marker.equal{\n    background-color: #77c6f2;\n    border: 1px solid #64b0db;\n    padding: 5px;\n}\n.marker.big {\n    background-color: #69bd6df5;\n    border: 1px solid #57a85bf5;\n    padding: 5px;\n}\n.mapboxgl-canvas{\n    position: static;\n}\n.mapboxgl-canvas-container.mapboxgl-touch-zoom-rotate.mapboxgl-touch-drag-pan,\n.mapboxgl-canvas-container.mapboxgl-touch-zoom-rotate.mapboxgl-touch-drag-pan .mapboxgl-canvas{\n    height: 100% !important;\n    width: 100% !important;\n}\n.maincontant{\n    height: 100%;\n}\n.rightsection{\n    height: 100vh;\n}\n.mapcontrol {\n    position: fixed;\n    z-index: 1;\n    right: 25px;\n    top: 25px;\n    background-color: #fff;\n    padding: 15px;\n}\n\n.map-dots ul {\n    display: flex;\n    gap: 10px;\n    padding: 0;\n    margin: 0;\n    justify-content: center;\n}\n\n.map-dots ul li {\n    list-style-type: none;\n    text-align: center;\n}\n\n.mapDots {\n    /* background-color: #6c8997; */\n    border-radius: 50%;\n}\n\n.mapDots.small{\n    padding: 5px;\n    background-color: #f48787;\n}\n.mapDots.big {\n    padding: 5px;\n    background-color: #69bd6df5;\n}\n.mapDots.equal {\n    padding: 5px;\n    background-color: #77c6f2;\n}\n.map-height {\n    height: 45px;\n    display: flex;\n    align-items: end;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
